import Home from "@/components/frame/Home";

const home = {
  isShow: true,
  index: 12,
  path: "/nineSmallPlace",
  component: Home,
  redirect: "/nineSmallPlace/nineSmallPlace/nineHomePage",
  name: "nineSmallPlace",
  isHead: true,
  meta: {
    title: "九小场所",
    icon: "el-icon-s-cooperation"
  },
  children: [
    {
      path: "nineSmallPlace",
      component: () => import("@/views/nineSmallPlace/index"),
      name: "nineSmallPlace",
      meta: { title: "九小场所", close: false },
      children: [
        {
          path: "nineHomePage",
          name: "nineHomePage",
          component: () => import("@/views/nineSmallPlace/nineHomePage/index"),
          meta: {
            title: "首页",
            next: "/nineSmallPlace/nineSmallPlace/baseInfo",
            close: false
          }
        },
        {
          path: "baseInfo",
          name: "baseInfo",
          component: () => import("@/views/nineSmallPlace/baseInfo/index"),
          meta: {
            title: "场所基本信息",
            next: "/nineSmallPlace/nineSmallPlace/dailyCheckList",
            close: false
          }
        },

        {
          path: "inspectionRecords",
          name: "inspectionRecords",
          component: () =>
            import("@/views/nineSmallPlace/baseCheck/inspectionRecords/index"),
          meta: { title: "场所自查-巡查记录", close: false }
        },
        {
          path: "hiddenDanger",
          name: "hiddenDanger",
          component: () =>
            import("@/views/nineSmallPlace/baseCheck/hiddenDanger/index"),
          meta: { title: "场所自查-隐患清单", close: false }
        },
        {
          path: "inspection",
          name: "inspection",
          component: () =>
            import("@/views/nineSmallPlace/supervise/inspection/index"),
          meta: { title: "监督检查-巡查记录", close: false }
        },
        {
          path: "hiddenDangerList",
          name: "hiddenDangerList",
          component: () =>
            import("@/views/nineSmallPlace/supervise/hiddenDangerList/index"),
          meta: { title: "监督检查-隐患清单", close: false }
        },
        {
          path: "inspectors",
          name: "inspectors",
          component: () => import("@/views/nineSmallPlace/inspectors/index"),
          meta: {
            title: "检查人员账号管理",
            close: false
          }
        },
        {
          path: "safeProduction",
          name: "safeProduction",
          component: () =>
            import("@/views/nineSmallPlace/fourStandards/safeProduction/index"),
          meta: {
            title: "安全生产检查清单",
            close: false
          }
        },
        {
          path: "standardGuide",
          name: "standardGuide",
          component: () =>
            import("@/views/nineSmallPlace/fourStandards/standardGuide/index"),
          meta: {
            title: "标准化运行提升指南",
            close: false
          }
        },
        {
          path: "complianceDetails",
          name: "complianceDetails",
          component: () =>
            import(
              "@/views/nineSmallPlace/fourStandards/complianceDetails/index"
            ),
          meta: {
            title: "标准化达标细则",
            close: false
          }
        },
        {
          path: "gridOperator",
          name: "gridOperator",
          component: () =>
            import("@/views/nineSmallPlace/fourStandards/gridOperator/index"),
          meta: {
            title: "网格员检查原则",
            close: false
          }
        },
        {
          path: "dailyCheckList",
          name: "dailyCheckList",
          component: () =>
            import("@/views/nineSmallPlace/dailyCheckList/index"),
          meta: {
            title: "检查清单维护",
            next: "/nineSmallPlace/nineSmallPlace/hiddenDangerBank",
            close: false
          }
        },
        {
          path: "hiddenDangerBank",
          name: "hiddenDangerBank",
          component: () =>
            import("@/views/nineSmallPlace/hiddenDangerBank/index"),
          meta: {
            title: "场所隐患库",
            next: "/nineSmallPlace/nineSmallPlace/nineBaseInfoReport",
            close: false
          }
        },
        {
          path: "nineBaseInfoReport",
          name: "nineBaseInfoReport",
          component: () =>
            import("@/views/nineSmallPlace/analysis/nineBaseInfoReport"),
          meta: {
            title: "九小场所基本信息上报情况",
            next: "/nineSmallPlace/nineSmallPlace/nineTypeStatistics",
            close: true
          }
        },
        {
          path: "nineTypeStatistics",
          name: "nineTypeStatistics",
          component: () =>
            import("@/views/nineSmallPlace/analysis/nineTypeStatistics"),
          meta: {
            title: "九小场所类型统计表",
            next: "/nineSmallPlace/nineSmallPlace/nineSelfInspectionHidden",
            close: true
          }
        },
        {
          path: "nineSelfInspectionHidden",
          name: "nineSelfInspectionHidden",
          component: () =>
            import("@/views/nineSmallPlace/analysis/nineSelfInspectionHidden"),
          meta: { title: "九小场所自查隐患统计表", close: true }
        },
        {
          path: "hazardStatisticsTable",
          name: "hazardStatisticsTable",
          component: () =>
            import("@/views/nineSmallPlace/analysis/hazardStatisticsTable"),
          meta: { title: "九小场所监督检查隐患统计表", close: true }
        }
      ]
    }
  ]
};

export default home;



// WEBPACK FOOTER //
// ./src/router/modules/nineSmallPlace.js